/**
 * Honest Free Desk entry path.
 * No list-price matrix; Compare plans → /pricing.
 */

'use client'

import React from 'react'
import Link from 'next/link'

const STEPS = [
  {
    label: 'Name your paper agent',
    body: 'Create Free Desk without a card, then name one persistent agent. It is labeled PAPER everywhere.',
  },
  {
    label: 'Enter the paper desk',
    body: 'Observe market and portfolio views with 200 paper-only Desk Credits for paper activity and research.',
  },
  {
    label: 'Bring tools live when ready',
    body: 'Operator adds full chat and manual live trading. Desk adds the first live agent. Your paper agent state stays.',
  },
] as const

export const TrustSection: React.FC = () => {
  return (
    <section className="lp-section lp-section-path" id="access" aria-labelledby="access-title">
      <div className="lp-band lp-band-path">
        <header className="lp-path-intro">
          <p className="lp-kicker">Your first session</p>
          <h2 id="access-title" className="lp-section-title">
            Start on Paper. Keep What You Build.
          </h2>
          <p className="lp-section-lede">
            Free Desk gives you a named paper agent, market and portfolio views, research chat, and
            200 paper-only Desk Credits. Live orders and live agents stay locked until the matching
            paid plan.{' '}
            <Link href="/pricing" className="lp-inline-link">
              Compare plans
            </Link>
            .
          </p>
          <p className="lp-path-aside">
            Paper results are not live performance. Paused agents burn no credits, and their
            configuration is kept.
          </p>
        </header>

        <ol className="lp-path" aria-label="How to start">
          {STEPS.map((step, i) => (
            <li key={step.label} className="lp-path-step">
              <div className="lp-path-rail" aria-hidden="true">
                <span className="lp-path-node" />
                {i < STEPS.length - 1 ? <span className="lp-path-connector" /> : null}
              </div>
              <div className="lp-path-card">
                <h3 className="lp-path-label">{step.label}</h3>
                <p className="lp-path-body">{step.body}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}
